var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-space',_vm._l((_vm.actionComponents),function(actionComponent,index){return _c(actionComponent.component,_vm._b({key:index,tag:"component",on:{"submit":_vm.onChange}},'component',_vm.setComponentProps(actionComponent.props),false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }